import { render } from "./TermsofUse.vue?vue&type=template&id=5da6576c&scoped=true"
import script from "./TermsofUse.vue?vue&type=script&lang=js"
export * from "./TermsofUse.vue?vue&type=script&lang=js"

import "./TermsofUse.vue?vue&type=style&index=0&id=5da6576c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da6576c"]])

export default __exports__